import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Term = styled.div`
  font-size: 20px;
  margin: 0 15px 0 15px;
`;

export const Time = styled.input`
  font-size: 12px;
  background-color: transparent; ;
`;
